import * as actionTypes from './actionTypes';

// Set Filters
export const setFilters = (filters) => ({
  type: actionTypes.SET_FILTERS,
  payload: filters,
});

// Clear Filters
export const clearFilters = () => ({
  type: actionTypes.CLEAR_FILTERS,
});

// Set Pagination
export const setPagination = (pagination) => ({
  type: actionTypes.SET_PAGINATION,
  payload: pagination,
});

// Show Alert
export const showAlert = (message, type = 'info', duration = 5000) => (dispatch) => {
  const id = Date.now();
  dispatch({
    type: actionTypes.SHOW_ALERT,
    payload: { id, message, type },
  });

  setTimeout(() => {
    dispatch(hideAlert(id));
  }, duration);
};

// Hide Alert
export const hideAlert = (id) => ({
  type: actionTypes.HIDE_ALERT,
  payload: id,
});

// Set Loading
export const setLoading = (isLoading) => ({
  type: actionTypes.SET_LOADING,
  payload: isLoading,
});